import CryptoJS from 'crypto-js'

export class CryptoService {
    /**
     * 生成 Base64 编码的密钥和 IV
     */
    static generateKeyAndIV() {
        // 使用 Base64 编码
        const key = CryptoJS.enc.Base64.stringify(
            CryptoJS.lib.WordArray.random(32)
        ) // 256位
        const iv = CryptoJS.enc.Base64.stringify(
            CryptoJS.lib.WordArray.random(16)
        ) // 128位
        return { key, iv }
    }

    /**
     * AES 加密（使用 Base64 编码的 key/iv）
     */
    static encryptAES(data: string, key: string, iv: string) {
        try {
            // Base64 解码 key 和 iv
            const keyBytes = CryptoJS.enc.Base64.parse(key)
            const ivBytes = CryptoJS.enc.Base64.parse(iv)

            // 加密
            const encrypted = CryptoJS.AES.encrypt(data, keyBytes, {
                iv: ivBytes,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            })

            // 返回 Base64 字符串
            return encrypted.toString()
        } catch (error: any) {
            console.error('加密失败:', error)
            throw new Error(`加密失败: ${error.message}`)
        }
    }

    // 加密
    static AES(data: string) {
        const { key, iv } = this.generateKeyAndIV()
        try {
            const encrypt = this.encryptAES(data, key, iv)
            return {
                encrypt,
                key,
                iv,
                code: 1,
                msg: ''
            }
        } catch (err: any) {
            return {
                code: 0,
                msg: err?.message || '加密失败'
            }
        }
    }
}
